import CashRegisterDelete from './CashRegisterDelete'
export {CashRegisterDelete}
export default CashRegisterDelete
